<template>
	<div class="character ozzie">
		<div class="bg-cork"></div>
		<div class="strings"></div>
		<div class="post-mark"></div>
		<router-link @click="toTop" to="/" class="desktop-keys">
	    	<div class="keys"></div>
	    </router-link>
		<cc />
		<div class="vertical-string">
			<div class="media-wrapper">
				<div class="ch-photo"></div>

				<div class="player-wrapper" :class="{ 'disabled': audioUrl.length === 0 }">
		        	<AudioPlayer id="player1" :file="audioUrl" class="player"></AudioPlayer>
		        	<div class="label"><span>{{ lang('listen') }}</span></div>
		        </div>

		        <VDropdown :distance="-20" strategy="fixed"  @show="popperShowHandler('read-more')" @hide="popperHideHandler('read-more')">
			        <!-- This will be the popover target (for the events and position) -->
			        <div class="read-icon-wrapper" :class="{ 'disabled': readMore.length === 0, 'animate': readMore.length > 0 }">
			            <div class="read-icon-1"></div>
			            <div class="read-icon-2"></div>
			            <div class="read-icon-3"></div>
			            <div class="label"><span>{{ lang('read') }}</span></div>
			        </div>
			        <!-- This will be the content of the popover -->

			        <template #popper>
			            <div class="read-popper">
			              	<a class="popper-closer" v-close-popper><i class="fas fa-times-circle"></i></a>
			              	<ReadMore :popper-open="vPopperOpen" />
			            </div>
			        </template>
		        </VDropdown>

		        <VDropdown :distance="-20" strategy="fixed"  @show="popperShowHandler('evidence')" @hide="popperHideHandler('evidence')">
			        <div class="evidence-icon" :class="{ 'empty-evidence': $evidence.value === null, 'animate': $evidence.value !== null }">
			            <div class="label"><span>{{ lang('evidence') }}</span></div>
			        </div>

			        <!-- This will be the content of the popover -->
			        <template #popper>
			            <div class="evidence-popper">
			              	<a class="popper-closer" v-close-popper><i class="fas fa-times-circle"></i></a>
			              	<OzzieEvidence />
			            </div>
			        </template>
		        </VDropdown>
			</div>
		</div>

		<!-- CONTENT SCROLL -->
		<div class="character-d" scroll="no">
			<div class="slides">
				<TopTextBox :items="textBoxData" />

				<!-- composition -->
				<div class="composition zoom">
					<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/00_OzzieHouse@2x.png" alt="">

					<start1 />
					<sleepingarea2 />
					<room3 />
					<hand4 />
					<notice5 />
					<hand6 />
					<forclosure7 />
					<hand8 />
					<house9 />
					<certificate10 />
					<hand11 />
					<hand12 />
					<pickets13 />
					<foto14 />
					<foto15 />
					<foto16 />
					<foto17 />
					<foto18 />
				</div>
				<!-- // composition -->

				<ControlsButton :data="controlsButtonData" />
				<cc-control></cc-control>
				<langControl/>
				<black_overlay id="black_overlay" :overlay="overlay" />
      			<outro id="outro" :outro="outro" />
			</div>
		</div>
		<!-- // CONTENT SCROLL -->
	</div>
</template>

<script>
	import AudioPlayer from '../../components/audioPlayer.vue';
	import ControlsButton from '../../components/controlsButton';
	import controlsButtonData from './ozzie/controlsButtonData';
	import outro from './outro.vue';
	import black_overlay from './black_overlay.vue';
	import TopTextBox from '../components/TopTextBox';
	import textBoxData from './ozzie/text-box';
	import ReadMore from '../components/ReadMore.vue';
	import evidence from '../components/evidence.vue';
	import cc from '../../components/cc.vue'
	import cc_control from '../../components/cc_control.vue'
	import langControl from '../../components/langControl.vue'

	import start1 from './ozzie/start-1.vue';
	import sleepingarea2 from './ozzie/sleepingarea-2.vue';
	import room3 from './ozzie/room-3.vue';
	import hand4 from './ozzie/hand-4.vue';
	import notice5 from './ozzie/notice-5.vue';
	import hand6 from './ozzie/hand-6.vue';
	import forclosure7 from './ozzie/forclosure-7.vue';
	import hand8 from './ozzie/hand-8.vue';
	import house9 from './ozzie/house-9.vue';
	import certificate10 from './ozzie/certificate-10.vue';
	import hand11 from './ozzie/hand-11.vue';
	import hand12 from './ozzie/hand-12.vue';
	import pickets13 from './ozzie/pickets-13.vue';
	import foto14 from './ozzie/foto-14.vue';
	import foto15 from './ozzie/foto-15.vue';
	import foto16 from './ozzie/foto-16.vue';
	import foto17 from './ozzie/foto-17.vue';
	import foto18 from './ozzie/foto-18.vue';

	export default {
		name: 'holly',
		inject: ['helpers', 'lang'],
		components: {
			AudioPlayer,
			ControlsButton,
			outro,
    		black_overlay,
    		TopTextBox,
    		ReadMore,
    		'OzzieEvidence': evidence,
			cc,
			'cc-control': cc_control,
			langControl,

			start1,
			sleepingarea2,
			room3,
			hand4,
			notice5,
			hand6,
			forclosure7,
			hand8,
			house9,
			certificate10,
			hand11,
			hand12,
			pickets13,
			foto14,
			foto15,
			foto16,
			foto17,
			foto18
		},
		data() {
			return {
				controlsButtonData,
				audioUrl: '',
				textBoxData,
				showModal: false,
				vPopperOpen: false,
      			readMore: '',

				outro: [
					{
					    start: 37500,
					    end: 38300,
					    fromStyle: { bottom: '-150%', opacity: 0.8 },
						toStyle: { bottom: '0%', opacity: 1 }
					}
				],

				overlay: [
					{
					    start: 37500,
					    end: 38300,
					    fromStyle: { opacity: '0' },
					    toStyle: { opacity: '0.9' },
					    easing: 'linear'
					}
				]
			}
		},
		mounted() {
		    window.document.querySelector('html').scrollTo({
		    	top: 0,
		    	behavior: "instant"
		    });
		    setTimeout(() => {
		    	this.helpers.enableScrolling();
		    }, 1000);
		},
		created() {
		    this.$watch('$audioUrl.value', (newVal) => {
		    	this.setAudioUrl(newVal);
		    }, { immediate: true });

		    this.$watch('$readMore.value', (newVal) => {
		    	this.setReadMore(newVal);
		    }, { immediate: true });
		},
		methods: {
			setAudioUrl(value) {
		    	this.audioUrl = value;
		    },
		    setReadMore(value) {
		    	this.readMore = value;
		    },
		    popperShowHandler(type) {
			    setTimeout(() => {
			        document.querySelector('.v-popper__popper--shown').classList.add(type);
			    }, 500);
			    this.vPopperOpen = true;
		    },
		    popperHideHandler() {
			    const self = this;      // this.helpers.enableScrolling();
			    setTimeout(() => {
			        document.querySelector('.v-popper__popper--shown').classList.remove('evidence');
			        document.querySelector('.v-popper__popper--shown').classList.remove('read-more');

			        self.vPopperOpen = false;
			    }, 500);
		    },
		    toTop() {
			    window.scrollTo({
			        top: 0,
			        behavior: 'smooth'
			    });
			    this.helpers.enableScrolling();
		    }
		}
	}
</script>

<style lang="scss" scoped>
	html {
		-ms-overflow-style: none;  /* IE and Edge */
		scrollbar-width: none;  /* Firefox */
		&::-webkit-scrollbar {
			display: none;
		}

		.controls-button {
			bottom: 59px;
		}
	}

	.ozzie {
		.ch-photo {background-image: url('/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie@2x.png') !important;}
		.post-mark {
			background-image: url('/themes/rise-theme/dist/images/estate/character-view/post-mark-4.png') !important;
			@media(max-width: 600px) {
				display: none;
			}
		}
	}

	.composition {
		position: fixed;
		top: calc(50% - 320px);
		left: calc(50% - 250px);
		max-width: 600px;
		width: 100%;
	}

	.slides {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		z-index: 5;
	}

	.comment-box {opacity: 0;}

	@media screen and (max-width: 1600px) {
		.composition {
			top: calc(50% - 295px);
			left: calc(50% - 235px);
			max-width: 550px;
			width: 100%;
		}
	}

	@media screen and (max-width: 991px) {
		.composition {
		    top: calc(50% - 234px);
		    left: calc(50% - 187px);
		    max-width: 450px;
		}
	}

	@media screen and (max-width: 650px) {
		.composition {
			top: calc(50% - 170px);
			left: calc(50% - 150px);
			max-width: 300px;
		}
	}

	@media screen and (max-width: 991px) and (orientation: landscape) {
		.character-d .zoom {zoom: 0.6 !important;}
	}
</style>
